import { Menu, Typeahead } from "react-bootstrap-typeahead";
import styled, { css } from "styled-components";

export const TypeaheadContainer = styled.div`
	width: ${({ width }) => width} !important;
	border-top: 1px solid #d9d9d9;
	border-left: 1px solid #d9d9d9;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	border-bottom-left-radius: 0px;
	border-bottom-right-radius: 0px;
	position: relative;
	background: #ffffff;
	${({ showShadow }) =>
		showShadow &&
		css`
			box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.15);
		`}
		${({ showAI }) =>
		showAI &&
		css`
			border: 1px solid #d9d9d9;
			border-bottom-left-radius: 0px;
			border-bottom-right-radius: 0px;
			border-radius: 4px;
			overflow: hidden;

		`}

`;

export const CustomTypeahead = styled(Typeahead)`
	.form-control {
		display: flex;
		align-items: center;
		min-height: 47px;
		border: none !important;
		background: #fff;
		padding: 8px;
	}

	.rbt-input-main {
		margin: 0;
	}

	.rbt-input-multi {
		display: flex;
		align-items: center;
		font-size: 14px;
	}
	.rbt-input-multi.focus {
		box-shadow: none;
	}

	.rbt-input-multi .rbt-input-wrapper {
		width: 100%;
	}

	.rbt-input-multi .rbt-input-main {
		width: 100%;
	}

	.dropdown-menu::-webkit-scrollbar-thumb {
		background-color: #ffffff;
	}

	.dropdown-menu::-webkit-scrollbar-track {
		background-color: #ffffff;
	}

	.dropdown-menu.show {
		width: 100%;
		max-height: max-content !important;
		height: fit-content !important;
		border-radius: 4px;
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
		position: absolute;
		width: 100.3%;
		left: -1px;
		display: flex !important;
		flex-direction: column !important;
		justify-content: space-between !important;
		${({ showShadow }) =>
		showShadow &&
		css`
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
			`}

	}
`;

export const CustomMenu = styled(Menu)`
	overflow: unset !important;
`;

export const ListContainer = styled.div`
	height: ${({ height }) => (height ? `${height}px` : "inherit")} !important;
	width: 100% !important;
	overflow-x: hidden;
	${({ isVirtualScroll }) =>
		!isVirtualScroll &&
		css`
			overflow-y: scroll;
		`}
`;

export const MenuItem = styled.div`
	max-width: 100%;
	padding: 8px;
	display: flex;
	align-items: center;
	cursor: pointer;
	:hover {
		border-radius: 4px;
		background: #efefef;
	}
`;

export const MenuLabel = styled.div`
	display: flex;
	align-items: center;
	height: 32px;
	padding: 4px;
	color: #595959;
	font-family: "Inter";
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 12px;
	margin-left: 8px;
`;

export const EmptyListLabel = styled.div`
	color: #605f60;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
`;

export const MenuBody = styled.div`
	padding: 8px;
`;

export const AIButtonWrapper = styled.div`
	position: absolute;
	right: 5px;
	top : -40px;
	z-index: 500;
`